import React from 'react';

// "Skip to next year" nav glyph (Figma: chevron + vertical bar), 18x18.
// stroke=currentColor is load-bearing: it inherits the parent button's colour
// token across default/hover/disabled states — a hosted-image URL cannot do
// this, which is why it is an Svg component (same pattern as CalendarIcon).
const LastYearIcon = ({ className }: { className?: string }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path d="M6.75 13.5L11.25 9L6.75 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.75 4.5V13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default LastYearIcon;
